import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchUserRoles(id) {
  try {
    const url = paths.fetchRolesIMS(id);
    const response = await axiosInstance.get(url);
    return response?.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchUserRoles = () => {
  return useMutation({
    mutationFn: fetchUserRoles,
  });
};

export { useFetchUserRoles };
